// Action types for fetching data
export const FETCH_STORE_TEMP_SUCCESS = 'FETCH_STORE_TEMP_SUCCESS';
export const FETCH_STORE_TEMP_FAILURE = 'FETCH_STORE_TEMP_FAILURE';
// Action types for saving data
export const SAVE_STORE_TEMP_REQUEST = 'SAVE_STORE_TEMP_REQUEST';
// Fetch data actions
export const fetchStoreTempSuccess = (payload) => ({
    type: FETCH_STORE_TEMP_SUCCESS,
    payload,
});
export const fetchStoreTempFailure = (error) => ({
    type: FETCH_STORE_TEMP_FAILURE,
    payload: error,
});
// Save data actions
export const saveStoreTempDataRequest = (payload) => ({
    type: SAVE_STORE_TEMP_REQUEST,
    payload
});
